export const OPTION_TYPE = {
  LOADING: 'LOADING',
  INFINITE_LOADING: 'INFINITE_LOADING',
  HINT: 'HINT',
  ERROR: 'ERROR',
  CREATE: 'CREATE',
  BLANK: 'BLANK',
  SELECT_ALL: 'SELECT_ALL',
} as const;
